document.addEventListener('DOMContentLoaded', function(){
    const paginaturnos= document.querySelector('#turnos-eliminar');
    if(paginaturnos){ 
        const formulariosEliminar= document.querySelectorAll('.formulario-eliminar');
        formulariosEliminar.forEach(formulario =>{
            formulario.addEventListener('submit', (e)=>{
                e.preventDefault();
                    Swal.fire({
                        title: '¿Estás seguro?',
                        text: "Esta acción no se puede deshacer y el turno será cancelado.",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6', 
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sí, eliminar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            formulario.submit();
                        }
                    })            
                });
        });
    }
});